/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-13 14:09:12
 */
import React, { FC, useEffect, useState } from "react";
import { Descriptions, Button, Space } from "antd";
import axios from "@/axios/axios";
import defaultImg from "@/img/defaultProject.png";
import { PayModal } from "./payModal/index";
interface listProps {
  creditValue: number;
  id: number;
  count: number;
}
export const OnLineByCard: FC<any> = ({ history, storeData }) => {
  const [showPayModal, setShowModal] = useState(false);
  const [commodityList, setCommodityList] = useState<listProps[]>([]);
  const [commodityInfo, setCommodityInfo] = useState<{
    productId: number;
    quantity: number;
    count: number;
  }>({
    productId: 0,
    quantity: 0,
    count: 0,
  });
  const getCollectionList = async () => {
    const { data } = await axios.post("/shop/front/ce/product/list");
    setCommodityList(
      data.map((item: listProps) => {
        return {
          ...item,
          count: 0,
        };
      })
    );
  };
  useEffect(() => {
    getCollectionList();
  }, []);
  return (
    <div>
      <h2>在线购卡</h2>
      <Descriptions title="" layout="vertical" bordered={true}>
        {commodityList.map((item: any, index: number) => {
          return (
            <>
              <Descriptions.Item label="学习卡信息">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <p>
                      <img src={item.imageAllPath} alt="" width={200} />
                    </p>
                    <Space>
                      <p>
                        <Button
                          size="small"
                          onClick={() => {
                            if (commodityList[index].count <= 0) return;
                            commodityList[index].count =
                              commodityList[index].count - 1;
                            setCommodityList([...commodityList]);
                          }}
                        >
                          -
                        </Button>
                        <span>&emsp;{item.count}&emsp;</span>
                        <Button
                          size="small"
                          onClick={() => {
                            commodityList[index].count =
                              commodityList[index].count + 1;
                            setCommodityList([...commodityList]);
                          }}
                        >
                          +
                        </Button>
                      </p>
                      <p>
                        <Button
                          type="primary"
                          onClick={() => {
                            setShowModal(true);
                            setCommodityInfo({
                              productId: commodityList[index].id,
                              quantity: commodityList[index].creditValue,
                              count: commodityList[index].count,
                            });
                          }}
                          disabled={commodityList[index].count === 0}
                        >
                          购买
                        </Button>
                      </p>
                    </Space>
                  </div>
                  <div>
                    <p>{item.productName}</p>
                    <p>学习卡有效：{item.validDateRange}</p>
                  </div>
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="使用说明">
                <div>
                  <p>学分数量：{item.creditValue}</p>
                  <p>使用范围：全部CME项目I、II类通用</p>
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="价格">
                {item.salePriceText}
              </Descriptions.Item>
            </>
          );
        })}
      </Descriptions>
      <PayModal
        showPayModal={showPayModal}
        setShowModal={setShowModal}
        commodityInfo={commodityInfo}
      />
    </div>
  );
};
